import Logo from 'assets/images/logo_new.svg';
import Notification from 'assets/images/notification.png';
import Profile from 'assets/images/profile.svg';
import useClick from 'hooks/useClick';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import UserActions from 'store/stores/User/actions';
import Format from 'utils/Formatter';
import { AUTHENTICATION, PERMISSIONS } from './constants';
import Styled from './styles';
import AuthAPI from 'services/apis/AuthAPI';

const Navbar = () => {
  const dispatch = useDispatch();
  const dropDownRef = useRef(null);
  const history = useHistory();
  const { t } = useTranslation('layouts');
  const [isDropDown, setIsDropDown] = useClick(dropDownRef);
  const [toggle, setToggle] = useState(false);
  const user = useSelector(state => state.User.user);
  const localAuthAPI = new AuthAPI();
  const [stats, setStats] = useState({});

  const onGetStats = () => {
    localAuthAPI
      .infoOne()
      .then(response => {
        if (response) {
          setStats(response);
        }
      })
      .catch(error => {
        console.error('Error fetching stats:', error);
      });
  };

  useEffect(() => {
    onGetStats();
  }, []);

  useEffect(() => {
    if (toggle) document.body.style.overflow = 'hidden';
    else document.body.removeAttribute('style');
  }, [toggle]);

  const onLogout = () => {
    dispatch(UserActions.SetIsLogin(false));
    history.push('/login/');
  };

  return (
    <Styled.Nav id="navbar">
      <Styled.Container>
        <Styled.Toggle
          className={`${toggle ? 'active' : ''}`}
          onClick={() => setToggle(!toggle)}
        >
          <span className={'bar'} />
          <span className={'bar'} />
          <span className={'bar'} />
        </Styled.Toggle>

        <Styled.Logo to={'/'}>
          <img src={Logo} alt={''} />
        </Styled.Logo>

        <Styled.Menu className={`${toggle ? 'toggle' : ''}`}>
          {toggle && (
            <span className={'close'} onClick={() => setToggle(false)}>
              {t('nabbar.toggle.close')}
            </span>
          )}
          <Link to={'/'} className={'item'}>
            {t('navbar.menu.home')}
          </Link>
          <Link
            to={{
              pathname:
                'https://www.azarakhshsolar.ir/%d8%b3%d9%88%d9%84%d8%a7%d8%aa-%d9%85%d8%aa%d8%af%d8%a7%d9%88%d9%84/'
            }}
            target="_blank"
            className={'item'}
          >
            {t('navbar.menu.stock')}
          </Link>
          <Link
            to={{
              pathname:
                'https://www.azarakhshsolar.ir/%d8%aa%d9%85%d8%a7%d8%b3-%d8%a8%d8%a7-%d9%85%d8%a7/'
            }}
            target="_blank"
            className={'item'}
          >
            {t('navbar.menu.contact')}
          </Link>
        </Styled.Menu>

        <Styled.Actions>
          {user ? (
            <>
              <Styled.Profile
                ref={dropDownRef}
                isDropDown={isDropDown}
                onClick={() => setIsDropDown(!isDropDown)}
              >
                <img src={Profile} alt={''} />
                <span
                  className={'text'}
                >{`${user?.firstName} ${user?.lastName}`}</span>
              </Styled.Profile>

              <div className={'notification'}>
                <span className={'counter'}>0</span>
                <img src={Notification} alt={''} />
              </div>

              <Styled.DropDown isDropDown={isDropDown}>
                <div className={'details'}>
                  <div className={'avatar'} />
                  <div className={'text'}>
                    <div className={'user'}>
                      {`${user?.firstName} ${user?.lastName} | `}
                      <span className={'mobile'}>
                        {Format.formatPhoneNumber('0' + user?.mobile)}
                      </span>
                    </div>
                    <div
                      className={`log ${
                        user?.authStep === AUTHENTICATION[0].step ||
                        (user?.rejectedReason !== null &&
                          user?.rejectedReason !== undefined)
                          ? 'error'
                          : user?.authStep === AUTHENTICATION[8].step
                          ? user?.permissions.includes(PERMISSIONS[1].step)
                            ? 'success'
                            : 'doing'
                          : 'doing'
                      }`}
                    >
                      {user?.authStep === AUTHENTICATION[0].step
                        ? user?.rejectedReason !== null &&
                          user?.rejectedReason !== undefined
                          ? `${t('navbar.log.step.rejected')} ${
                              user?.rejectedReason
                            }`
                          : t('navbar.log.step.0')
                        : user?.authStep === AUTHENTICATION[8].step
                        ? user?.permissions.includes(PERMISSIONS[1].step)
                          ? t('navbar.log.step.end')
                          : t('navbar.log.step.doing')
                        : t('navbar.log.step.begin', {
                            step: t(
                              AUTHENTICATION.find(
                                _step => _step.step === user?.authStep
                              )?.title
                            )
                          })}
                    </div>
                    <div className={'log'}>
                      {user?.authStep === AUTHENTICATION[8].step
                        ? t('navbar.log.stock.empty')
                        : t('navbar.log.stock.not_empty')}
                    </div>
                  </div>
                </div>
                <div className={'buttons'}>
                  <Link to={'/dashboard/'} className={'dashboard'}>
                    {t('navbar.dropdown.dashboard')}
                  </Link>
                  <div className={'logout'} onClick={onLogout}>
                    {t('navbar.dropdown.logout')}
                  </div>
                </div>
              </Styled.DropDown>
            </>
          ) : (
            <>
              <Styled.Button to={'/login/'} type={'secondary'}>
                {t('navbar.button.login')}
              </Styled.Button>
              {stats && stats.lastDays ? (
                <Styled.Button to={'/register/'} type={'primary'}>
                  {t('navbar.button.stock')}
                </Styled.Button>
              ) : (
                ''
              )}
            </>
          )}
        </Styled.Actions>
      </Styled.Container>
    </Styled.Nav>
  );
};

export default Navbar;
